export default {"src":"/_next/static/media/cog.3cf87699.svg","height":24,"width":24};